import classnames from 'classnames';
import * as React from 'react';

import { Content } from './content';
import { Header } from './header';
import { Icons } from './icons';
import { Person } from './person';
import styles from './teamCard.module.scss';

type PropsT = {
  className?: string;
  isOpen: boolean;
  children: React.ReactNode;
};

export class TeamCard extends React.PureComponent<PropsT> {
  static get Header() {
    return Header;
  }

  static get Content() {
    return Content;
  }

  static get Icons() {
    return Icons;
  }

  static get Person() {
    return Person;
  }

  render() {
    const { className, isOpen, children } = this.props;

    const rootClass = classnames(
      {
        [styles.cardTeam]: true,
        [styles.cardTeamOpen]: isOpen,
      },
      className,
    );

    const header = React.Children.map(children, (child: any) => {
      if (child && child.type.displayName === 'Header') {
        return child;
      }
      return null;
    });

    const content = React.Children.map(children, (child: any) => {
      if (child && child.type.displayName === 'Content') {
        return child;
      }
      return null;
    });

    return (
      <div className={rootClass}>
        {header}
        {content}
      </div>
    );
  }
}
